import { render, staticRenderFns } from "./Sazonal.vue?vue&type=template&id=bdaf8822&scoped=true&"
import script from "./Sazonal.vue?vue&type=script&lang=js&"
export * from "./Sazonal.vue?vue&type=script&lang=js&"
import style0 from "./Sazonal.vue?vue&type=style&index=0&id=bdaf8822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf8822",
  null
  
)

component.options.__file = "Sazonal.vue"
export default component.exports